import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './blueBlock.module.scss';
class BlueBlock extends Component {
  render() {
    const { children } = this.props;
    return <div className={styles.blueBlock}>{children}</div>;
  }
}

BlueBlock.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default BlueBlock;
